import { styled } from '@mui/material/styles';

export const StyledCreateAppDialogContent = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;
  .app-info {
    display: flex;
    gap: 16px;
  }
  .info-item {
    width: 288px;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  .date-item {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  @media only screen and (max-width: 600px) {
    .app-info {
      flex-direction: column;
    }
    .info-item {
      width: 100%;
    }
    .date-item {
      width: 100%;
    }
  }
`;

export const StyledCreateAppDialogAction = styled('div')`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  @media only screen and (max-width: 600px) {
    width: 100%;
    justify-content: center;
    .button-1 {
      flex: 1;
      button {
        width: 100%;
      }
    }
  }
`;
